import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import {
    Line, Bar, Pie, Text, Gauge, Treemap, Radar, MultiText,
} from 'frontend-charts'
import ModalHeader from '../../../UniformComponents/ModalHeader'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'
import Tabs from './Tabs'
import Accordion from '../../ReportV2/components/Accordion'
import Checkbox from '../../form/Checkbox'
import Spinner from '../../../UniformComponents/Spinner'
import Input from '../../form/Input'
import ChartPreview from './ChartPreview'

@observer
class ChartOptions extends Component {
chartPropResets = [
    {
        path: ['yAxis', 'axisLabel', 'show'],
        value: false,
    },
    {
        path: ['yAxis', 'splitLine', 'show'],
        value: false,
    },
    {
        path: ['xAxis', 0, 'axisLabel', 'show'],
        value: false,
    },
    {
        path: ['xAxis', 0, 'show'],
        value: false,
    },
    {
        path: ['tooltip', 'show'],
        value: false,
    },
]

    charts = [
        {
            chart: <Bar
                chartData={[
                    {
                        name: 'series A',
                        data: [
                            1,
                            2,
                            3,
                        ],
                    },
                ]}
                benchmarkData={[
                    {
                        name: 'series B',
                        data: [
                            3,
                            3,
                            1,
                        ],
                    },
                ]}
                style={{ height: '90px', width: '150px' }}
                layoutEdit={this.chartPropResets}
            />,
            title: 'Grouped column chart',
            description: 'The bar graph helps to compare the different sets of data among different groups easily.',
            key: 'groupedColumn',
            defaultSize: 8,
        },
        {
            chart: <Bar
                chartData={[
                    {
                        name: 'series A',
                        data: [
                            1,
                            2,
                            3,
                        ],
                    },
                ]}
                style={{ height: '90px', width: '150px' }}
                layoutEdit={this.chartPropResets}
            />,
            title: 'Column chart',
            description: 'The bar graph helps to compare the different sets of data among different groups easily.',
            key: 'column',
            defaultSize: 8,
        },
        {
            chart: <Bar
                xAxisLabels={['label one', 'label two', 'label three']}
                chartData={[
                    {
                        name: 'series A',
                        data: [
                            1,
                            2,
                            3,
                        ],
                    },
                    {
                        name: 'series B',
                        data: [
                            3,
                            1,
                            1,
                        ],
                    },
                ]}
                style={{ height: '90px', width: '150px' }}
                layoutEdit={this.chartPropResets}
            />,
            title: 'Stacked bar chart',
            description: 'The bar graph helps to compare the different sets of data among different groups easily.',
            key: 'stackedColumn',
            defaultSize: 8,
        },
        {
            chart: <Bar
                chartData={[
                    {
                        name: 'series A',
                        data: [
                            1,
                            2,
                            3,
                        ],
                    },
                ]}
                style={{ height: '90px', width: '150px' }}
                layoutEdit={[
                    {
                        path: ['xAxis', 'axisLabel', 'show'],
                        value: false,
                    },
                    {
                        path: ['xAxis', 'splitLine', 'show'],
                        value: false,
                    },
                    {
                        path: ['yAxis', 0, 'axisLabel', 'show'],
                        value: false,
                    },
                    {
                        path: ['yAxis', 0, 'show'],
                        value: false,
                    },
                    {
                        path: ['tooltip', 'show'],
                        value: false,
                    },
                ]}
                transpose
            />,
            title: 'Bar chart',
            description: 'The bar graph helps to compare the different sets of data among different groups easily.',
            key: 'bar',
            defaultSize: 4,
        },
        {
            chart: <Bar
                xAxisLabels={['label one', 'label two', 'label three']}
                chartData={[
                    {
                        name: 'series A',
                        data: [
                            1,
                            2,
                            3,
                        ],
                    },
                    {
                        name: 'series B',
                        data: [
                            3,
                            1,
                            1,
                        ],
                    },
                ]}
                style={{ height: '90px', width: '150px' }}
                layoutEdit={[
                    {
                        path: ['xAxis', 'axisLabel', 'show'],
                        value: false,
                    },
                    {
                        path: ['xAxis', 'splitLine', 'show'],
                        value: false,
                    },
                    {
                        path: ['yAxis', 0, 'axisLabel', 'show'],
                        value: false,
                    },
                    {
                        path: ['yAxis', 0, 'show'],
                        value: false,
                    },
                    {
                        path: ['tooltip', 'show'],
                        value: false,
                    },
                ]}
                transpose
            />,
            title: 'Stacked bar chart',
            description: 'The bar graph helps to compare the different sets of data among different groups easily.',
            key: 'stackedBar',
            defaultSize: 4,
        },
        {
            chart: <Pie
                chartData={[
                    {
                        value: 20,
                        name: 'series 1',
                    },
                    {
                        value: 30,
                        name: 'series 2',
                    },
                    {
                        value: 10,
                        name: 'series 3',
                    },
                    {
                        value: 40,
                        name: 'series 4',
                    },
                    {
                        value: 30,
                        name: 'series 5',
                    },
                    {
                        value: 60,
                        name: 'series 6',
                    },
                ]}
                style={{ height: '90px', width: '150px' }}
                layoutEdit={[
                    {
                        path: ['legend', 'show'],
                        value: false,
                    },
                    {
                        path: ['tooltip', 'show'],
                        value: false,
                    },
                ]}
                compact
            />,
            title: 'Pie chart',
            description: 'The bar graph helps to compare the different sets of data among different groups easily.',
            key: 'pie',
            defaultSize: 2,
        },
        {
            chart: <Pie
                chartData={[
                    {
                        value: 20,
                        name: 'series 1',
                    },
                    {
                        value: 30,
                        name: 'series 2',
                    },
                    {
                        value: 10,
                        name: 'series 3',
                    },
                    {
                        value: 40,
                        name: 'series 4',
                    },
                    {
                        value: 30,
                        name: 'series 5',
                    },
                    {
                        value: 60,
                        name: 'series 6',
                    },
                ]}
                style={{ height: '90px', width: '150px' }}
                layoutEdit={[
                    {
                        path: ['legend', 'show'],
                        value: false,
                    },
                    {
                        path: ['tooltip', 'show'],
                        value: false,
                    },
                ]}
                compact
                donut
            />,
            title: 'Donut chart',
            description: 'The bar graph helps to compare the different sets of data among different groups easily.',
            key: 'donut',
            defaultSize: 2,
        },
        {
            chart: <Treemap
                chartData={[
                    {
                        value: 20,
                        name: 'series 1',
                    },
                    {
                        value: 30,
                        name: 'series 2',
                    },
                    {
                        value: 10,
                        name: 'series 3',
                    },
                    {
                        value: 40,
                        name: 'series 4',
                    },
                    {
                        value: 30,
                        name: 'series 5',
                    },
                    {
                        value: 60,
                        name: 'series 6',
                    },
                ]}
                style={{ height: '90px', width: '150px' }}
                layoutEdit={[
                    {
                        path: ['legend', 'show'],
                        value: false,
                    },
                    {
                        path: ['tooltip', 'show'],
                        value: false,
                    },
                ]}
                compact
                donut
            />,
            title: 'Treemap chart',
            description: 'The bar graph helps to compare the different sets of data among different groups easily.',
            key: 'treemap',
            defaultSize: 4,
        },
        {
            chart: <Radar
                chartData={[
                    {
                        name: 'series A',
                        data: [
                            1,
                            2,
                            3,
                        ],
                    },
                ]}
                indicators={[{ name: 'series A' }]}
                style={{ height: '90px', width: '150px' }}
            />,
            title: 'Radar chart',
            description: 'The bar graph helps to compare the different sets of data among different groups easily.',
            key: 'radar',
            defaultSize: 8,
        },
        {
            chart: <Text
                mainText="$1000.50"
                subText="Company net sales"
                style={{ height: '90px', width: '150px' }}
            />,
            title: 'Text chart',
            description: 'The bar graph helps to compare the different sets of data among different groups easily.',
            key: 'text',
            defaultSize: 2,
        },
        {
            chart: <Line
                chartData={[
                    {
                        name: 'series A',
                        data: [
                            0,
                            1,
                            2,
                            3,
                        ],
                    },
                ]}
                benchmarkData={[
                    {
                        name: 'series B',
                        data: [
                            1,
                            2,
                            3,
                            4,
                        ],
                    },
                ]}
                style={{ height: '90px', width: '150px' }}
                layoutEdit={this.chartPropResets}
            />,
            title: 'Line chart',
            description: 'The bar graph helps to compare the different sets of data among different groups easily.',
            key: 'line',
            defaultSize: 8,
        },
        {
            chart: <Line
                xAxisLabels={['label one', 'label two', 'label three']}
                chartData={[
                    {
                        name: 'series A',
                        data: [
                            0,
                            1,
                            2,
                            3,
                        ],
                    },
                    {
                        name: 'series B',
                        data: [
                            1,
                            4,
                            3,
                            4,
                        ],
                    },
                ]}
                style={{ height: '90px', width: '150px' }}
                layoutEdit={this.chartPropResets}
                type="stack"
            />,
            title: 'Stacked line chart',
            description: 'The bar graph helps to compare the different sets of data among different groups easily.',
            key: 'stackedLine',
            defaultSize: 8,
        },
        {
            chart: <Gauge
                chartData={45}
                style={{ height: '90px', width: '150px' }}
                containerSize={{ height: 190, width: 190 }}
                layoutEdit={[
                    {
                        path: ['series', 0, 'pointer', 'width'],
                        value: 15,
                    },
                    {
                        path: ['series', 0, 'axisTick', 'distance'],
                        value: -15,
                    },
                    {
                        path: ['series', 0, 'detail', 'rich', 'a', 'fontSize'],
                        value: 25,
                    },
                    {
                        path: ['series', 0, 'detail', 'rich', 'a', 'lineHeight'],
                        value: 25,
                    },
                    {
                        path: ['series', 0, 'detail', 'offsetCenter'],
                        value: [0, '35%'],
                    },
                ]}
            />,
            title: 'Gauge chart',
            description: 'The bar graph helps to compare the different sets of data among different groups easily.',
            key: 'gauge',
            defaultSize: 2,
        },
        {
            chart: <Gauge
                chartData={4}
                style={{ height: '90px', width: '150px' }}
                containerSize={{ height: 190, width: 190 }}
                layoutEdit={[
                    {
                        path: ['series', 0, 'pointer', 'width'],
                        value: 15,
                    },
                    {
                        path: ['series', 0, 'axisTick', 'distance'],
                        value: -15,
                    },
                    {
                        path: ['series', 0, 'detail', 'rich', 'a', 'fontSize'],
                        value: 25,
                    },
                    {
                        path: ['series', 0, 'detail', 'rich', 'a', 'lineHeight'],
                        value: 25,
                    },
                    {
                        path: ['series', 0, 'detail', 'offsetCenter'],
                        value: [0, '35%'],
                    },
                ]}
            />,
            title: '0 to 5 Gauge chart',
            description: 'The bar graph helps to compare the different sets of data among different groups easily.',
            key: 'gauge0-5',
            defaultSize: 2,
        },
        {
            chart: <MultiText
                chartData={[
                    <div style={{ fontSize: '12px' }}>Data One</div>,
                    <div style={{ fontSize: '12px' }}>Data Two</div>,
                    <div style={{ fontSize: '12px' }}>Data Three</div>,
                    <div style={{ fontSize: '12px' }}>Data Four</div>,
                ]}
                style={{ height: '90px', width: '150px' }}
                containerSize={{ height: 190, width: 190 }}
            />,
            title: 'Multi Text Chart',
            description: 'The bar graph helps to compare the different sets of data among different groups easily.',
            key: 'multiText',
            defaultSize: 2,
        },
    ]

    sizes = [
        {
            name: 'Small',
            divs: 4,
            size: 2,
        },
        {
            name: 'Medium',
            divs: 2,
            size: 4,
        },
        {
            name: 'Large',
            divs: 1,
            size: 8,
        },
    ]

    constructor(props) {
        super(props)
        this.state = {
            error: {
                chart: false,
                previewChart: '',
                openSizes: false,
            },
        }
    }

    renderSizes = ({ name, divs, size }) => {
        const { dashboardWizardStore } = this.props
        const { setChartSize, newWidget } = dashboardWizardStore
        const arrDivs = []
        for (let i = 0; i < divs; i += 1) {
            arrDivs.push(<div className="sizeDiv" />)
        }
        return (
            <div
                className={`sizeContainer  ${size === newWidget.defaultSize ? 'active' : ''}`}
                onClick={() => {
                    if (size !== newWidget.defaultSize) setChartSize(size)
                }}
            >
                <div className="illustration">
                    {arrDivs}
                </div>
                <div className="description">
                    <div className="name">{name}</div>
                    <div className="input">
                        <Checkbox
                            onBlur={() => {
                                if (size !== newWidget.defaultSize) setChartSize(size)
                            }}
                            checked={size === newWidget.defaultSize}
                        />
                    </div>
                </div>
            </div>
        )
    }

    renderChartSizes = () => this.sizes.map((size) => this.renderSizes(size))

    closePreview = () => {
        this.setState({ previewChart: '' })
    }

    renderChart = ({
        chart, title, description, key, defaultSize,
    }) => {
        const { dashboardWizardStore } = this.props
        const { setChart, newWidget } = dashboardWizardStore
        const { error } = this.state
        return (
            <div
                className={`chartContainer ${key === newWidget.chart ? 'active' : ''}`}
                onClick={() => {
                    if (key !== newWidget.chart) setChart(key, defaultSize)
                    this.setState({ error: { ...error, chart: false } })
                }}
            >
                <div className="chart">
                    {chart}
                </div>
                <div className="description">
                    <div className="title">
                        {title}
                        <i
                            style={{ marginLeft: '20px', cursor: 'pointer' }}
                            className="fa-solid fa-magnifying-glass"
                            onClick={() => this.setState({ previewChart: key })}
                        />
                        <ChartPreview
                            isOpen={this.state.previewChart === key}
                            close={this.closePreview}
                            dashboardWizardStore={dashboardWizardStore}
                            chart={key}
                        />
                    </div>
                    <div className="subTitle">{description}</div>
                </div>
                <div className="input">
                    <Checkbox
                        onBlur={() => {
                            if (key !== newWidget.chart) setChart(key, defaultSize)
                            this.setState({ error: { ...error, chart: false }, openSizes: true })
                        }}
                        checked={key === newWidget.chart}
                    />
                </div>
            </div>
        )
    }

    renderCharts = () => {
        const { dashboardWizardStore } = this.props
        const { newWidget, dashStore } = dashboardWizardStore
        const { getChartScope, oId } = dashStore
        const dataLevel = (newWidget.dataLevel === 'product' ? 'event' : newWidget.dataLevel) === getChartScope(oId) ? 'currentLevel' : 'levelBelow'
        const chartPath = ['KPI', 'multiQuestion'].includes(newWidget.nonQuestionType)
            ? [newWidget.nonQuestionType, dataLevel]
            : [newWidget.questionTypeCode, newWidget.isNumeric, dataLevel]
        const allowedCharts = ['KPI', 'multiQuestion'].includes(newWidget.nonQuestionType)
            ? R.pathOr([], chartPath, dashboardWizardStore.questionChartOptions)
            : R.pathOr(
                R.pathOr([], chartPath, dashboardWizardStore.questionChartOptions),
                [...chartPath, newWidget.displayAs],
                dashboardWizardStore.questionChartOptions,
            )

        return this.charts
            .filter((c) => allowedCharts.includes(c.key))
            .map((c) => this.renderChart(c))
    }

    addWidget = () => {
        const { dashboardWizardStore } = this.props
        const { newWidget, addWidget } = dashboardWizardStore
        const { error } = this.state
        if (!newWidget.chart) {
            this.setState({ error: { ...error, chart: true } })
            return
        }
        addWidget()
    }

    changeTitle = ({ value }) => {
        const { dashboardWizardStore } = this.props
        const { changeNewWidget } = dashboardWizardStore
        changeNewWidget(value, 'widgetTitle')
    }

    render() {
        const { dashboardWizardStore } = this.props
        const {
            previousStage, loading, getDefaultTitle,
        } = dashboardWizardStore
        const { error, openSizes } = this.state

        if (loading) return <Spinner />
        return (
            <div className="chartOptions">
                <Tabs dashboardWizardStore={dashboardWizardStore} />
                <ModalHeader cssClass="header">
                    <div className="title">
                        Chart Options
                    </div>
                    <div className="subTitle">
                        Select your widget type
                    </div>
                </ModalHeader>
                <div className="body" style={{ padding: '0 100px' }}>
                    <Input
                        name="title"
                        defaultValue={getDefaultTitle()}
                        onBlur={this.changeTitle}
                        label="Enter a title for your chart"
                        style={{ marginBottom: '15px' }}
                    />
                    <div className="accordian widgetType" style={{ marginBottom: '15px' }}>
                        <Accordion
                            cssClass="chartAccordian"
                            title={(
                                <div className="title">
                                    Select your widget type
                                    <i
                                        className="fa-regular fa-circle-exclamation"
                                        style={
                                            {
                                                color: 'red',
                                                background: 'none',
                                                marginLeft: '20px',
                                                display: error.chart ? 'block' : 'none',
                                            }
                                        }
                                    />
                                </div>
                            )}
                            openIcon="fa-regular fa-chevron-up"
                            closeIcon="fa-regular fa-chevron-down"
                            defaultOpen
                        >
                            <div className="widgets">
                                {this.renderCharts()}
                            </div>
                        </Accordion>
                    </div>
                    <div className="accordian widgetSize">
                        <Accordion
                            cssClass="chartAccordian"
                            title={(
                                <div className="title">
                                    Select a size
                                </div>
                            )}
                            openIcon="fa-regular fa-chevron-up"
                            closeIcon="fa-regular fa-chevron-down"
                            isOpen={openSizes}
                        >
                            <div
                                className="info"
                            >
                                <i className="fa-solid fa-circle-info" />
                                <p>
                                    You will be able to customise the widget
                                    size within the edit dashboard view
                                </p>
                            </div>
                            <div className="chartSizes">{this.renderChartSizes()}</div>
                        </Accordion>
                    </div>
                </div>
                <ModalFooter>
                    <Button
                        label="Back"
                        cssClass="tertiary regular"
                        style={{ marginRight: '25px', width: '134px' }}
                        onClick={previousStage}
                    />
                    <Button
                        label="Add Widget"
                        cssClass="primary regular"
                        style={{ width: '134px' }}
                        onClick={this.addWidget}
                    />
                </ModalFooter>
            </div>
        )
    }
}

export default ChartOptions
